import styled from 'styled-components';

// Constellation Components
import {
    token,
    Text,
} from '@zillow/constellation';

export const StyledBannerText = styled(Text)`
    font-weight: bold;
    text-align: center;
`;

export const StyledInvoicePaymentContainer = styled.div`
    background: white;
    margin-bottom: 20px;
    border: 1px solid ${token('colors.gray300')};
    border-radius: 5px;
`;
